import React, { Component } from 'react';
import {
  DtpFormGroup,
  DtpControlLabel,
  DtpFormControlFeedback,
} from 'dtp-react-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  MaskedInput,
  Radio,
  TextInput,
  Select,
  Button,
} from '../index';
import DatePicker from './DatePicker';
import validateCpf from './validacoes';
import Checkbox from './Checkbox';

class Input extends Component {
  constructor(props) {
    super(props);
    const { value } = this.props;
    const validation = this.checkValidity(value);
    this.state = { error: !validation.isValid, touched: false };
    // , validated: validation.validated };
  }

  getValueInJsonFormat = (inputValue) => {
    let retorno = this.props.itemList || this.props.date ? inputValue : inputValue.target.value;
    const regexCaracteresEspeciais = new RegExp('[<>!=()*\'\\\\"]', 'g');
    if (this.props.date) {
      retorno = moment(inputValue).format('DD/MM/YYYY');
    }
    if (this.props.integer) {
      retorno = retorno.replace(/\D/g, '');
    }
    if (this.props.nitElado) {
      const regex = new RegExp('[^0-9,]', 'g');
      retorno = retorno.replace(regex, '');
    }
    if (this.props.currency) {
      const regex = new RegExp('[^0-9.,]', 'g');
      retorno = retorno.replace(regex, '');

      if (retorno === ',') {
        retorno = retorno.toString().replace(',', '');
      }
      if (retorno === '.') {
        retorno = retorno.toString().replace('.', '');
      }

      retorno = retorno.toLocaleString('pt-BR', { currency: 'BRL' });
    }
    if (this.props.itemList) {
      // se vier a sigla da UF ('RJ','SP')
      if (Number.isNaN(parseFloat(retorno))) {
        return retorno;
      }
      // se o id da uf iniciar por zero ('02000')
      // Estava transformando para numero e perdendo o zero a esquerda
      // e então o valor da combobox não ficava marcado.
      if (!Number.isInteger(retorno)) {
        if (retorno.substr(0, 1) === '0') {
          return retorno;
        }
      }
    }
    if (this.props.dadosBancarios) {
      retorno = retorno.replace(/\D/g, '');
    }
    if (this.props.number) {
      if (retorno === '') {
        retorno = '';
      } else {
        retorno = Number(retorno);
      }
    }
    if (this.props.filtroExigencia) {
      retorno = retorno.replace(/\W/g, '');
    }
    if (this.props.textarea || this.props.consultaFilaGet) {
      if (retorno.match(regexCaracteresEspeciais)) {
        retorno = retorno.replace(regexCaracteresEspeciais, '');
      }
    }
    return retorno;
  }

  getValueFromJsonFormat = (jsonValue) => {
    let retorno = jsonValue;
    if (this.props.date && !this.props.disabled) {
      if (retorno) {
        retorno = moment(jsonValue, 'DD/MM/YYYY').toDate();
      } else {
        retorno = undefined;
      }
    }
    if (retorno && this.props.currency) {
      if (typeof (jsonValue) === 'number') {
        retorno = jsonValue.toFixed(2);
      }
      retorno = retorno.toString().replace(/\D/g, '');
      retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
      retorno = retorno.toLocaleString('pt-BR', { currency: 'BRL' });
    }
    if (retorno && this.props.participation) {
      retorno = retorno.toFixed(8).toString().replace(/\./g, ',');
    }
    return retorno;
  }

  checkValidity = (value) => {
    let isValid = true;
    let validated = false;
    if (this.props.required) {
      isValid = Boolean(value) && value !== null && `${value}`.trim() !== '' && isValid;
      validated = true;
    }
    if (this.props.minLength) {
      isValid = Boolean(value) && value.length >= this.props.minLength && isValid;
      validated = true;
    }
    if (this.props.cpf) {
      isValid = validateCpf(value);
      validated = true;
    }
    if (this.props.nit) {
      isValid = Boolean(value) && value.length === 11 && isValid;
      validated = true;
    }
    if (this.props.currency) {
      isValid = value !== 0 && isValid;
      validated = true;
    }

    return { isValid, validated };
  }

  handleChange = (e) => {
    let value = null;
    let validation = true;
    if (this.props.type === 'file') {
      [value] = e.target.files;
    }
    if (this.props.check) {
      value = e.target.checked;
    } else {
      value = e !== undefined && e !== null ? this.getValueInJsonFormat(e) : null;
      validation = this.checkValidity(value);
    }
    this.setState({ error: !validation.isValid });

    if (this.props.onChange) {
      this.props.onChange({ value, isValid: validation.isValid });
    }
  }

  handleBlur = (e) => {
    const value = e ? this.getValueInJsonFormat(e) : null;
    const validation = this.checkValidity(value);
    const retorno = value;
    if (this.props.onBlur) {
      this.setState({
        touched: true,
        error: !validation.isValid,
      }, () => this.props.onBlur(e));
    } else {
      this.setState({
        touched: true,
        error: !validation.isValid,
      });
    }
    if (retorno && this.props.currency) {
      // retorno = retorno.replace(/\./g, '').replace(/,/g, '.');
      // retorno = Number(retorno);
      this.setState({
        touched: true,
        error: !validation.isValid,
      }, () => this.props.onChange({ value: retorno, isValid: validation.isValid }));
    }
  }

  handleValueReceived = value => (
    this.getValueFromJsonFormat(value)
  )

  handleValidationState = () => {
    if (this.props.exibirBotao) {
      return 'null';
    }
    if (!this.state.touched && !this.props.touched) {
      return 'null';
    }
    if (!this.props.error) {
      return 'success';
    }
    if (this.props.error || this.state.error) {
      return 'error';
    }
    return 'success';
  }

  pickComponentType = () => {
    if (this.props.radio) {
      return Radio;
    }
    if (this.props.itemList) {
      return Select;
    }
    if (this.props.mask) {
      return MaskedInput;
    }
    if (this.props.date) {
      return DatePicker;
    }
    if (this.props.check) {
      return Checkbox;
    }
    return TextInput;
  }

  render() {
    const Element = this.pickComponentType();
    return (
      <DtpFormGroup
        className={this.props.required ? 'required' : ''}
        validationState={this.props.validationState ?
          this.props.validationState : this.handleValidationState()}
      >
        <DtpControlLabel
          animate={this.props.animate}
          label={this.props.check ? null : this.props.label}
        />
        <DtpFormControlFeedback />
        <Element
          {...this.props}
          disabled={this.props.disabled}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onKeyUp={this.props.onKeyUp}
          onKeyDown={this.props.onKeyDown}
          onFocus={this.props.onFocus}
          required={this.props.required}
          type={this.props.type}
          value={this.handleValueReceived(this.props.value)}
        />
        {this.props.exibirBotao &&
          <div className={this.props.value ? 'botao-lapis-segregacao-massa-verde' : 'botao-lapis-segregacao-massa-cinza'}>
            <Button
              onClick={this.props.onClickDoBotao}
              hint={this.props.hintDoBotao}
              mini
              icon={this.props.iconeDoBotao}
              disabled={this.props.disabledBotao}
              className={this.props.classe ? this.props.classe : ''}
            />
          </div>
        }
      </DtpFormGroup>
    );
  }
}

Input.propTypes = {
  // Boolean para ativar a animação no campo
  animate: PropTypes.bool,
  // Boolean que indica validacao para regras de cpf
  cpf: PropTypes.bool,
  // Boolean que indica formato financeiro
  check: PropTypes.bool.isRequired,
  currency: PropTypes.bool,
  // Desativar input
  disabled: PropTypes.bool,
  // Propriedade que indica erro na validacao do campo
  error: PropTypes.bool,
  // Lista para ser renderizada e utilizada para selecionar o tipo de input para select ou radio
  itemList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })),
  // Indica que input deve retornar valor inteiro (sem mascara)
  integer: PropTypes.bool,
  // Label que descreve o campo
  label: PropTypes.string.isRequired,
  // Mascara para o input
  mask: PropTypes.arrayOf(PropTypes.string),
  // Valida input em relacao ao seu tamanho maximo permitido
  maxLength: PropTypes.number,
  // Valida input em relacao ao seu tamanho minimo exigido
  minLength: PropTypes.number,
  // Indica que input deve ser validado com as regras de nit
  nit: PropTypes.bool,
  // Indica que input deve ser validado com as regras de nit
  nitElado: PropTypes.bool,
  // Indica que o formato do input no json deve ser numerico
  number: PropTypes.bool,
  // Recebe função para o evento de perda de foco (onBlur)
  onBlur: PropTypes.func,
  // Recebe função para o evento de mudança de caracteres no campo
  participation: PropTypes.bool,
  // Boolean para sinalizar se o tipo é radio
  radio: PropTypes.bool,
  // Boolean para sinalizar se o campo é obrigatório ou não
  required: PropTypes.bool,
  // Propriedade utilizada para sinalizar que o input foi utilizado
  touched: PropTypes.bool,
  // Tipo de conteúdo a ser inserido no campo
  type: PropTypes.string,
  // Data
  date: PropTypes.bool,
  // Estado de validacao
  validationState: PropTypes.string,
  // Valor do input
  value: PropTypes.string,
  dadosBancarios: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  exibirBotao: PropTypes.bool,
  hintDoBotao: PropTypes.string,
  iconeDoBotao: PropTypes.string,
  onClickDoBotao: PropTypes.func,
  disabledBotao: PropTypes.bool,
  classe: PropTypes.string,
};

Input.defaultProps = {
  animate: false,
  cpf: false,
  currency: false,
  disabled: false,
  error: false,
  integer: false,
  itemList: null,
  mask: null,
  maxLength: null,
  minLength: null,
  nit: false,
  nitElado: false,
  number: false,
  participation: false,
  radio: false,
  required: false,
  touched: false,
  type: 'text',
  validationState: null,
  value: '',
  date: false,
  dadosBancarios: false,
  onBlur: null,
  onChange: null,
  onKeyDown: null,
  onKeyUp: null,
  onFocus: null,
  exibirBotao: false,
  disabledBotao: false,
  hintDoBotao: null,
  iconeDoBotao: null,
  onClickDoBotao: null,
  classe: '',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Input.jsx